import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Avatar from '../Avatar';
import { flowRight as compose } from 'lodash';
import UnreadThreadsQuery from '../Message/getUnreadThreads.graphql';
import { withQuery } from '../../hoc/withGraphql';

import icon from '/public/SiteIcons/menuIcon.svg'
import s from './DropDownMenu.css';

class DropDownMenu extends React.Component {

  static propTypes = {
    allUnreadThreadsCount: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getUnreadCount: PropTypes.shape({
        total: PropTypes.number.isRequired,
      }),
    }),
  };

  static defaultProps = {
    allUnreadThreadsCount: {
      loading: true,
      getUnreadCount: {
        total: 0,
      },
    },
  };


  render() {

    const { allUnreadThreadsCount: { loading, getUnreadCount } } = this.props;
    let count = 0;
    if (!loading && getUnreadCount != null) {
      count = getUnreadCount.total != null ? getUnreadCount.total : 0;
    }
    const isNewMessage = count > 0;


    return (
      <div className={s.menuBg}>
        {isNewMessage && <span className={cx(s.notification, 'notificationHeaderRTL')} />}
        <span>
          <img src={icon} alt='Menu Icon' />
        </span>
        <span>
          <Avatar
            isUser
            type={'small'}
            height={32}
            width={32}
            className={s.userAvatar}
          />
        </span>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  withQuery(UnreadThreadsQuery, {
    name: 'allUnreadThreadsCount',
    options: {
      ssr: false,
    },
  }),
)(DropDownMenu);
